// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","textTitle":"HL9E8x","textSubtitle":"hp7Mth","textDisclaimer":"eoG0PP","generateButton":"updh_z"};